import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'


const incomingOrderProducts = {
  firestorePath: '/incoming-order-products',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'incomingOrderProducts',
  statePropName: 'incomingOrderProducts',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions

  state, getters, mutations, actions
}

export default incomingOrderProducts